define('validation--counter-emails',['exports'], function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    // Not sure if this has to be here
    var validate = function validate(node, value) {
        var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

        switch (node.type) {
            case 'email':

                if (value === '-') {
                    return true;
                }

                node.classList.remove('f-email-correct');
                node.classList.remove('f-email-incorrect');

                if (value && re.test(value)) {
                    node.classList.add('f-email-correct');
                    return true;
                } else {
                    node.classList.add('f-email-incorrect');
                    return false;
                }
            default:
                return !!value;
        }
    };

    exports.default = function () {
        var answers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];


        if (!Array.isArray(answers)) {
            return false;
        }

        return answers.length && answers.length === answers.filter(function (o) {
            var node = document.getElementById(o.id);
            return !node || !node.value ? false : validate(node, node.value.trim());
        }).length ? true : false;
    };
});
